export default "__VITE_ASSET__097bebdc__$_?react__"